import { render, staticRenderFns } from "./SaldoIndicacao.vue?vue&type=template&id=06980973&scoped=true"
import script from "./SaldoIndicacao.vue?vue&type=script&lang=js"
export * from "./SaldoIndicacao.vue?vue&type=script&lang=js"
import style0 from "./SaldoIndicacao.vue?vue&type=style&index=0&id=06980973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06980973",
  null
  
)

export default component.exports